var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { attrs: { id: "appFooter" } }, [
    _vm._v("TdsAppService " + _vm._s(_vm.serverVersion)),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }